"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var queryString_1 = require("../helpers/queryString");
/** @deprecated This model appears to have no active consumers. Defer cleanup to a separate task. */
var ImportsModel = /** @class */ (function () {
    function ImportsModel($http, APPURL) {
        this.$http = $http;
        this.APPURL = APPURL;
        this.URLS = {
            FETCH: APPURL + "/api/v1/import",
            UPDATE: APPURL + "/api/v1/import",
            CREATE: APPURL + "/api/v1/import",
        };
        this.data = [];
        this.extract = this.extract.bind(this);
        this.cacheResults = this.cacheResults.bind(this);
    }
    ImportsModel.prototype.extract = function (result) {
        return result.data;
    };
    ImportsModel.prototype.cacheResults = function (result) {
        this.data = this.extract(result);
        return this.data;
    };
    ImportsModel.prototype.show = function (id) {
        return this.$http
            .get(this.URLS.FETCH + "/" + id)
            .then(this.cacheResults);
    };
    ImportsModel.prototype.get = function (data) {
        if (data) {
            return this.$http
                .get(this.URLS.FETCH + "?" + (0, queryString_1.toQueryString)(data))
                .then(this.cacheResults);
        }
        return this.$http.get(this.URLS.FETCH).then(this.cacheResults);
    };
    ImportsModel.prototype.update = function (request) {
        return this.$http
            .put(this.URLS.FETCH + "/" + request.id, request)
            .then(this.cacheResults);
    };
    ImportsModel.prototype.synczones = function (data) {
        return this.$http.put(this.URLS.FETCH, data).then(this.cacheResults);
    };
    ImportsModel.prototype.create = function (request) {
        return this.$http
            .post(this.URLS.FETCH, request)
            .then(this.cacheResults);
    };
    ImportsModel.prototype.delete = function (data) {
        return this.$http
            .delete(this.URLS.FETCH + "/" + data.id)
            .then(this.cacheResults);
    };
    ImportsModel.prototype.search = function (params) {
        return this.$http
            .post(this.URLS.FETCH + "/search", params)
            .then(this.cacheResults);
    };
    ImportsModel.prototype.batchCreate = function (courses) {
        return this.$http
            .post(this.URLS.CREATE + "/batch", courses)
            .then(this.cacheResults);
    };
    return ImportsModel;
}());
ImportsModel.$inject = ["$http", "APPURL"];
exports.default = ImportsModel;
